let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("65smn")).then(() => parcelRequire('7MtzJ'));